import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { WixIcons } from '../../../../components/common';
import styles from '../EmptyState.scss';
import { IOuter } from '../EmptyState.types';

export const FavoritesSubtitle: FC<IOuter> = () => (
  <FormattedMessage
    id="empty-state.favorites-subtitle"
    values={{ star: <WixIcons.Star className={styles.favoritesStarIcon} /> }}
  />
);
